export default __webpack_public_path__ + "static/media/banner.e60f5597.jpg";